import React, { useEffect, useState } from 'react';
import { getConfig } from '../../../../utils/config';

const getLocationIcon = (locationType) => {
    switch (locationType) {
        case 'Railway Station':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
  <g id="Group_10421" data-name="Group 10421" transform="translate(-25 -792)">
    <g id="Group_889" data-name="Group 889" transform="translate(0 308)">
      <circle id="Ellipse_156" data-name="Ellipse 156" cx="18" cy="18" r="18" transform="translate(25 484)" fill="#4d78eb"/>
    </g>
    <g id="_172605_train_icon" data-name="172605_train_icon" transform="translate(32 800)">
      <path id="Path_2257" data-name="Path 2257" d="M22.129,11.277c0,.235-.132.426-.295.426H18.295c-.163,0-.295-.191-.295-.426v-.851c0-.235.132-.426.295-.426h3.539c.163,0,.295.191.295.426Z" transform="translate(-9.506 -5.743)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
      <rect id="Rectangle_1052" data-name="Rectangle 1052" width="22" height="22" fill="none"/>
      <line id="Line_189" data-name="Line 189" y1="2.058" x2="2.456" transform="translate(3.225 17.774)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.3"/>
      <line id="Line_190" data-name="Line 190" x1="2.456" y1="2.058" transform="translate(15.603 17.774)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.3"/>
      <path id="Path_2258" data-name="Path 2258" d="M12.4,4h-.848A2.433,2.433,0,0,0,9,6.289V17.733a2.433,2.433,0,0,0,2.554,2.289h8.514a2.433,2.433,0,0,0,2.554-2.289V6.289A2.433,2.433,0,0,0,20.068,4h-.822M17.1,4H14.586" transform="translate(-5.169 -2.297)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.3"/>
      <path id="Path_2259" data-name="Path 2259" d="M13,14.78a.733.733,0,0,1,.674-.78h6.741a.733.733,0,0,1,.674.78v3.547a.734.734,0,0,1-.674.781H13.674A.734.734,0,0,1,13,18.328Z" transform="translate(-6.338 -8.04)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
      <circle id="Ellipse_367" data-name="Ellipse 367" cx="1" cy="1" r="1" transform="translate(7 14)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
      <circle id="Ellipse_368" data-name="Ellipse 368" cx="1" cy="1" r="1" transform="translate(13 14)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
    </g>
  </g>
</svg>

            );
        case 'Bus Depot':
            return (
                <svg
                    id="Group_933"
                    data-name="Group 933"
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g id="Group_917" data-name="Group 917">
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            fill="#15509e"
                        />
                    </g>
                    <g
                        id="_172577_bus_icon"
                        data-name="172577_bus_icon"
                        transform="translate(9 9)"
                    >
                        <path
                            id="Path_2267"
                            data-name="Path 2267"
                            d="M40.09,44v1.159a.773.773,0,0,1-.772.772H37.772A.773.773,0,0,1,37,45.159v-.772"
                            transform="translate(-22.71 -27.007)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2268"
                            data-name="Path 2268"
                            d="M8.09,44.386v.772a.773.773,0,0,1-.772.772H5.772A.773.773,0,0,1,5,45.159V44"
                            transform="translate(-3.069 -27.007)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <rect
                            id="Rectangle_1054"
                            data-name="Rectangle 1054"
                            width="19"
                            height="19"
                            fill="none"
                        />
                        <path
                            id="Path_2269"
                            data-name="Path 2269"
                            d="M20.221,4.09C20.221,2.1,19.835,1,17.9,1H7.09C4.772,1,4,1.662,4,3.7V16.449c0,1.279,1.038,1.545,2.317,1.545H17.9c1.279,0,2.317-.266,2.317-1.545V4.09Z"
                            transform="translate(-2.455 -0.614)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <circle
                            id="Ellipse_371"
                            data-name="Ellipse 371"
                            cx="1.5"
                            cy="1.5"
                            r="1.5"
                            transform="translate(13 13)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <circle
                            id="Ellipse_372"
                            data-name="Ellipse 372"
                            cx="1.5"
                            cy="1.5"
                            r="1.5"
                            transform="translate(3 13)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2270"
                            data-name="Path 2270"
                            d="M46,13h.772a.386.386,0,0,1,.386.386v3.09a.386.386,0,0,1-.386.386H46"
                            transform="translate(-28.234 -7.979)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2271"
                            data-name="Path 2271"
                            d="M2.159,13H1.386A.386.386,0,0,0,1,13.386v3.09a.386.386,0,0,0,.386.386h.772"
                            transform="translate(-0.614 -7.979)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2272"
                            data-name="Path 2272"
                            d="M22.883,5.159a.386.386,0,0,1-.386.386h-8.11A.386.386,0,0,1,14,5.159V4.386A.386.386,0,0,1,14.386,4H22.5a.386.386,0,0,1,.386.386Z"
                            transform="translate(-8.593 -2.455)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2273"
                            data-name="Path 2273"
                            d="M19.973,17.922l-10.814.03A1.024,1.024,0,0,1,8,16.793V12.159A1.024,1.024,0,0,1,9.159,11H19.973a1.024,1.024,0,0,1,1.159,1.159v4.635A1.19,1.19,0,0,1,19.973,17.922Z"
                            transform="translate(-4.91 -6.752)"
                            fill="none"
                            stroke="#fff"
                            strokeMiterlimit="10"
                            strokeWidth="1"
                        />
                    </g>
                </svg>
            );
        case 'Mall':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                <g id="Group_10406" data-name="Group 10406" transform="translate(-25 -1059)">
                  <g id="Group_918" data-name="Group 918" transform="translate(0 575)">
                    <circle id="Ellipse_156" data-name="Ellipse 156" cx="18" cy="18" r="18" transform="translate(25 484)" fill="#ecb600"/>
                  </g>
                  <path id="_290144_building_office_finance_buildings_icon_1_" data-name="290144_building_office_finance buildings_icon (1)" d="M6,21.24V9.36A1.76,1.76,0,0,1,7.76,7.6h0V5.84a.88.88,0,0,1,.88-.88h.88V1.44a.44.44,0,1,1,.88,0V4.96h.88a.88.88,0,0,1,.88.88V7.6h0a1.76,1.76,0,0,1,1.76,1.76v3.52H17V10.24h1.76V8.92H21.4v1.32h.44v11ZM11.28,6.28a.44.44,0,0,0-.44-.44H9.08a.44.44,0,0,0-.44.44V7.6h2.64Zm1.76,3.08a.88.88,0,0,0-.88-.88H7.76a.88.88,0,0,0-.88.88v11h6.16ZM17,13.76H13.92v6.6H17Zm3.96-2.64H17.88v9.24h3.08ZM19.2,12.44h.44a.44.44,0,0,1,.44.44v.44a.44.44,0,0,1-.44.44H19.2a.44.44,0,0,1-.44-.44v-.44A.44.44,0,0,1,19.2,12.44Zm0,2.64h.44a.44.44,0,0,1,.44.44v.44a.44.44,0,0,1-.44.44H19.2a.44.44,0,0,1-.44-.44v-.44A.44.44,0,0,1,19.2,15.08Zm0,2.64h.44a.44.44,0,0,1,.44.44v.44a.44.44,0,0,1-.44.44H19.2a.44.44,0,0,1-.44-.44v-.44A.44.44,0,0,1,19.2,17.72Zm-3.96-2.64h.44a.44.44,0,0,1,.44.44v.44a.44.44,0,0,1-.44.44h-.44a.44.44,0,0,1-.44-.44v-.44A.44.44,0,0,1,15.24,15.08Zm0,2.64h.44a.44.44,0,0,1,.44.44v.44a.44.44,0,0,1-.44.44h-.44a.44.44,0,0,1-.44-.44v-.44A.44.44,0,0,1,15.24,17.72Zm-3.96,1.32h-.44a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,11.28,19.04Zm0-2.64h-.44a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,11.28,16.4Zm0-2.64h-.44a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,11.28,13.76Zm0-2.64h-.44a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,11.28,11.12Zm-2.2,7.92H8.64a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,9.08,19.04Zm0-2.64H8.64a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,9.08,16.4Zm0-2.64H8.64a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,9.08,13.76Zm0-2.64H8.64a.44.44,0,0,1-.44-.44v-.44a.44.44,0,0,1,.44-.44h.44a.44.44,0,0,1,.44.44v.44A.44.44,0,0,1,9.08,11.12Z" transform="translate(29 1065)" fill="#fff" fill-rule="evenodd"/>
                </g>
              </svg>
              
            );
        case 'School':
            return (
                <svg
                    id="Group_935"
                    data-name="Group 935"
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_373"
                        data-name="Ellipse 373"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#15509e"
                    />
                    <g id="School" transform="translate(8.667 9.149)">
                        <path
                            id="Path_2274"
                            data-name="Path 2274"
                            d="M21.344,23.057h-.966v-7.4h.966a.322.322,0,0,0,.3-.441l-1.931-4.828a.322.322,0,0,0-.3-.2H13.62a.225.225,0,0,0-.045,0l-.92-.83V8.575h2.9a.322.322,0,0,0,.322-.322V6.322A.322.322,0,0,0,15.551,6H12.332a.322.322,0,0,0-.322.322V9.354l-.92.83a.225.225,0,0,0-.045,0H5.252a.322.322,0,0,0-.3.2L3.022,15.214a.322.322,0,0,0,.3.441h.966v7.4H3.321a.322.322,0,1,0,0,.644H21.344a.322.322,0,0,0,0-.644Zm-2.15-12.23,1.674,4.184H15.873V12.437a.457.457,0,0,0,0-.071.241.241,0,0,0,0-.051.476.476,0,0,0-.026-.042.5.5,0,0,0-.045-.061h0l-1.538-1.384Zm-6.54-4.184h2.575V7.931H12.654ZM5.471,10.828H10.4L8.9,12.2h0a.38.38,0,0,0-.042.058.354.354,0,0,0-.029.045.212.212,0,0,0,0,.048.608.608,0,0,0-.039.087v2.575H3.8ZM4.93,15.655H8.792v7.4H4.93Zm6.115,7.4V18.552H13.62v4.506Zm3.218,0V18.23a.322.322,0,0,0-.322-.322H10.723a.322.322,0,0,0-.322.322v4.828H9.436V12.578l2.9-2.649,2.9,2.649V23.057Zm1.609,0v-7.4h3.862v7.4Z"
                            transform="translate(-2.999 -6)"
                            fill="#fff"
                        />
                        <path
                            id="Path_2275"
                            data-name="Path 2275"
                            d="M13.609,44H12.322a.322.322,0,0,0-.322.322v1.287a.322.322,0,0,0,.322.322h1.287a.322.322,0,0,0,.322-.322V44.322A.322.322,0,0,0,13.609,44Zm-.322,1.287h-.644v-.644h.644Z"
                            transform="translate(-9.103 -31.77)"
                            fill="#fff"
                        />
                        <path
                            id="Path_2276"
                            data-name="Path 2276"
                            d="M47.609,44H46.322a.322.322,0,0,0-.322.322v1.287a.322.322,0,0,0,.322.322h1.287a.322.322,0,0,0,.322-.322V44.322A.322.322,0,0,0,47.609,44Zm-.322,1.287h-.644v-.644h.644Z"
                            transform="translate(-32.161 -31.77)"
                            fill="#fff"
                        />
                        <path
                            id="Path_2277"
                            data-name="Path 2277"
                            d="M29.287,28a1.287,1.287,0,1,0,1.287,1.287A1.287,1.287,0,0,0,29.287,28Zm0,1.931a.644.644,0,1,1,.644-.644A.644.644,0,0,1,29.287,29.931Z"
                            transform="translate(-19.954 -20.92)"
                            fill="#fff"
                        />
                    </g>
                </svg>
            );
        case 'Restaurants':
            return (
                <svg
                    id="Group_936"
                    data-name="Group 936"
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_374"
                        data-name="Ellipse 374"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#15509e"
                    />
                    <g id="Expanded" transform="translate(12 9)">
                        <g id="Group_924" data-name="Group 924">
                            <g
                                id="Group_920"
                                data-name="Group 920"
                                transform="translate(8.912)"
                            >
                                <path
                                    id="Path_2278"
                                    data-name="Path 2278"
                                    d="M30.446,18.8A.421.421,0,0,1,30,18.407V.392a.449.449,0,0,1,.891,0V18.407A.421.421,0,0,1,30.446,18.8Z"
                                    transform="translate(-30)"
                                    fill="#fff"
                                    stroke="#fff"
                                    strokeWidth="0.2"
                                />
                            </g>
                            <g
                                id="Group_921"
                                data-name="Group 921"
                                transform="translate(8.908)"
                            >
                                <path
                                    id="Path_2279"
                                    data-name="Path 2279"
                                    d="M33.114,13.813H30.441a.446.446,0,1,1,0-.891h2.226C32.607,5.435,31.069,1.043,30.433.89a.442.442,0,0,1-.442-.445A.449.449,0,0,1,30.441,0c1.866,0,3.119,6.912,3.119,13.367A.445.445,0,0,1,33.114,13.813Z"
                                    transform="translate(-29.991 0)"
                                    fill="#fff"
                                    stroke="#fff"
                                    strokeWidth="0.2"
                                />
                            </g>
                            <g id="Group_922" data-name="Group 922">
                                <path
                                    id="Path_2280"
                                    data-name="Path 2280"
                                    d="M13.119,8.02A3.123,3.123,0,0,1,10,4.9V.446a.446.446,0,1,1,.891,0V4.9a2.228,2.228,0,0,0,4.456,0V.446a.446.446,0,1,1,.891,0V4.9A3.123,3.123,0,0,1,13.119,8.02Z"
                                    transform="translate(-10)"
                                    fill="#fff"
                                    stroke="#fff"
                                    strokeWidth="0.2"
                                />
                            </g>
                            <g
                                id="Group_923"
                                data-name="Group 923"
                                transform="translate(2.673)"
                            >
                                <path
                                    id="Path_2281"
                                    data-name="Path 2281"
                                    d="M16.446,18.664A.42.42,0,0,1,16,18.275V.389a.45.45,0,0,1,.891,0V18.275A.42.42,0,0,1,16.446,18.664Z"
                                    transform="translate(-16)"
                                    fill="#fff"
                                    stroke="#fff"
                                    strokeWidth="0.2"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );
        case 'Medical Center':
            return (
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
  <g id="Group_10409" data-name="Group 10409" transform="translate(-25 -1244.646)">
    <circle id="Ellipse_375" data-name="Ellipse 375" cx="18" cy="18" r="18" transform="translate(25 1244.646)" fill="#4d78eb"/>
  </g>
  <g id="Group_10422" data-name="Group 10422" transform="translate(-932 -1565)">
    <g id="medicine-bottle-4" transform="translate(773.994 1509.28)">
      <path id="Path_6338" data-name="Path 6338" d="M180.638,250.667a.645.645,0,0,0-.662,1.108c.511.307,1.837,1.347,1.837,2.455v8.421a1.412,1.412,0,0,1-1.506,1.288H175.69c.006,0-1.277-.024-1.291,0h-2.7a1.411,1.411,0,0,1-1.506-1.288v-4.126a10.152,10.152,0,0,1,0-1.291v-3c0-1.009,1.345-2.126,1.862-2.471a.645.645,0,1,0-.713-1.076c-.25.165-2.44,1.67-2.44,3.547v8.421a2.7,2.7,0,0,0,2.8,2.579h8.6a2.7,2.7,0,0,0,2.8-2.579V254.23C183.1,252.16,180.739,250.727,180.638,250.667Z" transform="translate(0 -182.26)" fill="#fff"/>
      <path id="Path_6339" data-name="Path 6339" d="M294.488,67.607a.645.645,0,0,0,.645-.645,1.309,1.309,0,0,1,1.393-1.2h3.668a1.309,1.309,0,0,1,1.393,1.2.645.645,0,1,0,1.291,0,2.6,2.6,0,0,0-2.683-2.491h-3.668a2.6,2.6,0,0,0-2.683,2.491A.645.645,0,0,0,294.488,67.607Z" transform="translate(-122.354)" fill="#fff"/>
      <path id="Path_6340" data-name="Path 6340" d="M392.061,179.077a.645.645,0,1,0,0-1.291h-3.872a.645.645,0,1,0,0,1.291Z" transform="translate(-214.119 -110.975)" fill="#fff"/>
    </g>
    <path id="plus-38" d="M5.126,2.392H3.075V.342a.342.342,0,1,0-.683,0v2.05H.342a.342.342,0,0,0,0,.683h2.05v2.05a.342.342,0,0,0,.683,0V3.075h2.05a.342.342,0,0,0,0-.683Z" transform="translate(947.068 1582)" fill="#fff" stroke="#fff" stroke-width="0.5"/>
  </g>
</svg>

              
            );
        case 'Airport':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                <g id="Group_10410" data-name="Group 10410" transform="translate(-25 -1307)">
                  <circle id="Ellipse_376" data-name="Ellipse 376" cx="18" cy="18" r="18" transform="translate(25 1307)" fill="#14897b"/>
                  <g id="Layer_x0020_1" transform="translate(-25.156 1294.294)">
                    <path id="Path_2283" data-name="Path 2283" d="M67.314,22.352a8.8,8.8,0,0,0-.473,3.867.48.48,0,0,1-.506.481c-1.951.007-4.886.625-6.025,1.617a.676.676,0,0,0,.4,1.148H66.36a.481.481,0,0,1,.481.481A24.067,24.067,0,0,0,67.1,34.7a.48.48,0,0,1-.461.559c-.824.051-2.442.7-2.52,1.251-.082.583-.013.816.531.816h2.692a.482.482,0,0,1,.468.368c.146.487.29.915.416,1.27.128-.361.274-.8.423-1.294a.481.481,0,0,1,.46-.343h2.692c.545,0,.613-.233.531-.816-.028-.2-.326-.463-.763-.707a4.624,4.624,0,0,0-1.785-.547.48.48,0,0,1-.431-.556h0a24.067,24.067,0,0,0,.261-4.754.481.481,0,0,1,.481-.481h5.648a.676.676,0,0,0,.4-1.148c-1.2-1.046-4.007-1.558-6.063-1.618a.479.479,0,0,1-.466-.479h0a8.8,8.8,0,0,0-.473-3.867A.955.955,0,0,0,67.314,22.352Zm2.153,15.935c-.416,1.323-.8,2.194-.8,2.2a.48.48,0,0,1-.876,0s-.384-.873-.8-2.2H64.653c-1.236,0-1.633-.843-1.482-1.91s1.793-1.8,2.907-2.006a23.249,23.249,0,0,1-.2-3.945H60.712a1.637,1.637,0,0,1-1.033-2.836c1.3-1.131,4.046-1.714,6.2-1.831a8.15,8.15,0,0,1,.585-3.859,1.9,1.9,0,0,1,3.53,0,8.15,8.15,0,0,1,.585,3.859c2.153.117,4.9.7,6.2,1.831a1.637,1.637,0,0,1-1.033,2.836H70.579a23.249,23.249,0,0,1-.2,3.945c1.114.21,2.759.952,2.907,2.006s-.245,1.91-1.482,1.91Z" fill="#fff"/>
                  </g>
                </g>
              </svg>
              
            );
        case 'Commercial Hub':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_939"
                        data-name="Group 939"
                        transform="translate(0.473)"
                    >
                        <circle
                            id="Ellipse_377"
                            data-name="Ellipse 377"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(-0.473)"
                            fill="#15509e"
                        />
                        <g id="Skycraper" transform="translate(8.618 9)">
                            <path
                                id="Path_2284"
                                data-name="Path 2284"
                                d="M21.3,53.591h5.913a.3.3,0,0,0,0-.591H21.3a.3.3,0,1,0,0,.591Z"
                                transform="translate(-15.679 -38.219)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="0.3"
                            />
                            <path
                                id="Path_2285"
                                data-name="Path 2285"
                                d="M23.3,48.591h4.73a.3.3,0,1,0,0-.591H23.3a.3.3,0,1,0,0,.591Z"
                                transform="translate(-17.087 -34.697)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="0.3"
                            />
                            <path
                                id="Path_2286"
                                data-name="Path 2286"
                                d="M25.3,43.591h3.548a.3.3,0,1,0,0-.591H25.3a.3.3,0,1,0,0,.591Z"
                                transform="translate(-18.496 -31.175)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="0.3"
                            />
                            <path
                                id="Path_2287"
                                data-name="Path 2287"
                                d="M27.3,38.591h2.365a.3.3,0,0,0,0-.591H27.3a.3.3,0,0,0,0,.591Z"
                                transform="translate(-19.905 -27.653)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="0.3"
                            />
                            <path
                                id="Path_2288"
                                data-name="Path 2288"
                                d="M28.3,33.591h1.774a.3.3,0,1,0,0-.591H28.3a.3.3,0,0,0,0,.591Z"
                                transform="translate(-20.609 -24.131)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="0.3"
                            />
                            <path
                                id="Path_2289"
                                data-name="Path 2289"
                                d="M19.851,19.556h-2.1l-1.3-12.742a.3.3,0,0,0-.115-.2L11.754,3.062h0a.346.346,0,0,0-.08-.044.293.293,0,0,0-.281.044h0L6.811,6.61a.3.3,0,0,0-.112.2l-1.3,12.742H3.3a.3.3,0,0,0,0,.591H19.851a.3.3,0,1,0,0-.591Zm-3.941,0H7.236L11.573,4.372ZM7.272,7l3.769-2.918L6.621,19.556H5.989Zm9.253,12.555L12.105,4.082,15.875,7l1.283,12.555Z"
                                transform="translate(-3 -3)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="0.3"
                            />
                        </g>
                    </g>
                </svg>
            );

        default:
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                <g id="Group_10424" data-name="Group 10424" transform="translate(-25 -1429)">
                  <circle id="Ellipse_378" data-name="Ellipse 378" cx="18" cy="18" r="18" transform="translate(25 1429)" fill="#7700ed"/>
                  <g id="Group_10425" data-name="Group 10425" transform="translate(0 0.267)">
                    <path id="_9310112_star_sparkle_icon" data-name="9310112_star_sparkle_icon" d="M17.339,9.478c-5.423-1.041-6.163-1.781-7.2-7.2a.335.335,0,0,0-.657,0C8.437,7.7,7.7,8.437,2.274,9.478a.335.335,0,0,0,0,.657c5.423,1.041,6.163,1.781,7.2,7.2a.335.335,0,0,0,.657,0c1.041-5.423,1.781-6.163,7.2-7.2a.335.335,0,0,0,0-.657Z" transform="translate(33.194 1439.385)" fill="#fff"/>
                    <path id="_9310112_star_sparkle_icon-2" data-name="9310112_star_sparkle_icon" d="M10.121,5.96C7.25,5.409,6.858,5.017,6.307,2.146a.177.177,0,0,0-.348,0C5.409,5.017,5.017,5.409,2.146,5.96a.177.177,0,0,0,0,.348c2.871.551,3.263.943,3.814,3.814a.177.177,0,0,0,.348,0c.551-2.871.943-3.263,3.814-3.814a.177.177,0,0,0,0-.348Z" transform="translate(43.194 1433.73)" fill="#fff"/>
                    <path id="_9310112_star_sparkle_icon-3" data-name="9310112_star_sparkle_icon" d="M8.151,5C5.977,4.582,5.68,4.285,5.263,2.111a.134.134,0,0,0-.263,0C4.582,4.285,4.286,4.582,2.111,5a.134.134,0,0,0,0,.263C4.286,5.68,4.582,5.977,5,8.151a.134.134,0,0,0,.263,0c.417-2.174.714-2.471,2.888-2.888a.134.134,0,0,0,0-.263Z" transform="translate(31.199 1434.732)" fill="#fff"/>
                  </g>
                </g>
              </svg>
              
            );
    }
};

export default function AccordianNew({ highlightCategories }) {
    const [active, setActive] = useState(null);
    // const [show, setShow] = useState(false)

    const handleClick = (type) => {
        setActive(type);
        // setShow(prev => !prev)
    };

    const backButton = (active) => {
        if (active)
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.001"
                    height="13.314"
                    viewBox="0 0 14.001 13.314"
                    className='text-gray-200'
                >
                    <path
                        id="arrow-down"
                        d="M7.657,10.586l3.95-3.95A1,1,0,1,1,13.022,8.05L7.364,13.707a1,1,0,0,1-1.414,0L.293,8.05A1,1,0,1,1,1.707,6.636l3.95,3.95V1a1,1,0,0,1,2,0Z"
                        transform=""
                        fill="currentColor"
                    />
                </svg>
            );
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.001"
                height="13.314"
                viewBox="0 0 14.001 13.314"
                className='text-gray-200'

            >
                <path
                    id="arrow-down"
                    d="M7.657,10.586l3.95-3.95A1,1,0,1,1,13.022,8.05L7.364,13.707a1,1,0,0,1-1.414,0L.293,8.05A1,1,0,1,1,1.707,6.636l3.95,3.95V1a1,1,0,0,1,2,0Z"
                    transform="translate(0 13.314) rotate(-90)"
                    fill="currentColor"
                />
            </svg>
        );
    };

    const [padding, setPadding] = useState(0);

    // useEffect(()=>{
    //     Object.keys(highlightCategories).map((type) => {
    //         if(highlightCategories[type]?.length>padding)
    //             setPadding(highlightCategories[type]?.length);
    //             console.log('padding',highlightCategories[type]?.length);
    //     });
    // },[highlightCategories]);
    const config = getConfig()

    return (
        <div className={"ml-0 mt-4 lg:mt-0 lg:ml-4 grid grid-cols-1 lg:grid-cols-1 gap-y-3 "+ (padding>2?(`pb-36 lg:pb-0`):"pb-16 lg:pb-0")}>
            {Object.keys(highlightCategories).map((type, index) => (
                <div
                    key={type}
                    className={`relative ${config?.darkMode? 'border-[1px]' :'border-2'} border-gray-200 rounded-lg`}
                    onClick={() => handleClick(type)}
                    onMouseOver={() => {
                         setActive(type);
                        //  setShow(true)
                    }}
                    onMouseLeave={() => {
                        setActive(null);
                        // setShow(false)
                    }}
                >
                    <button
                        key={type}
                        id={type}
                        className={
                            (active === type ? 'bg-white text-black' : '') +
                             `flex space-x-4 px-4 w-full p-4 cursor-pointer justify-between `
                        }
                    >
                        <div className="flex w-full">
                            <div className='flex'>{getLocationIcon(type)}</div>
                            <p className={`font-medium ml-4 mr-2 flex-grow my-auto text-md text-left ` + (active===type?'text-black':'text-base-content')}>
                                {type}
                            </p>
                            <div className="flex-none my-auto">
                                {backButton(active === type)}
                            </div>
                        </div>
                    </button>
                    {active === type && (
                        <div
                            className={
                                (index % 2 == 0 ? '' : 'right-0') +
                                ' w-full lg:w-[100%] bg-yellow-50  z-10 '
                            }
                        >
                            <div className={`px-1 md:px-4 py-2 max-h-32 overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-300`}>
                                {highlightCategories[type].map((detail) => (
                                    <div
                                        key={detail.id}
                                        className="flex justify-between py-2 px-2"
                                    >
                                        <p className={`flex-1 text-black `}>
                                            {detail.name}
                                        </p>
                                        <p className={`pl-2 text-blue-900 font-medium `}>
                                            {detail.description}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
